import * as React from 'react';
import { useEffect } from 'react';
import { generateClassName } from 'utils';
import { getImageLibrary } from 'utils/FirebaseUtils';
import { getBaseURL } from 'utils/S3Utils';

interface ImageProps {
  imageUrl: string;
  selected: boolean;
  selecting: boolean;
  onSelect: (imageUrl: string) => void;
}

const ImageThumb: React.FunctionComponent<ImageProps> = props => {
  const { imageUrl, selected, selecting, onSelect } = props;
  return (
    <img
      className={generateClassName('images-grid-item', { selected, selecting })}
      src={imageUrl}
      // crossOrigin="anonymous"
      onClick={selected || selecting ? undefined : () => onSelect(imageUrl)}
    />
  );
};

interface Props {
  category: string;
  selectedImageUrl: string;
  onSelect: (imageUrl: string) => void;
  onSelectOther: () => void;
}

export const LibraryImagePicker = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { category, selectedImageUrl, onSelect, onSelectOther } = props;
    const [images, setImages] = React.useState<string[]>([]);
    const [selectingImageUrl, setSelectingImageUrl] = React.useState<
      string | null
    >(null);
    useEffect(() => {
      getImageLibrary(category).then(results => {
        setImages(results);
      });
    }, []);
    const didSelectThumb = (thumbUrl: string) => {
      const imageUrl = thumbUrl.replace('thumbs/', '');
      setSelectingImageUrl(imageUrl);
      onSelect(imageUrl);
    };

    return (
      <div className="library-image-picker" ref={ref}>
        <div className="images-grid">
          {images.map((fileName, index) => {
            const thumbUrl =
              getBaseURL() +
              'templates/library/' +
              category +
              '/thumbs/' +
              fileName;
            const selected = selectedImageUrl.includes(fileName);
            const selecting =
              !selected &&
              selectingImageUrl !== null &&
              selectingImageUrl.includes(fileName);
            return (
              <ImageThumb
                key={index}
                imageUrl={thumbUrl}
                selected={selected}
                selecting={selecting}
                onSelect={didSelectThumb}
              />
            );
          })}
        </div>
        <button className="template-ui-options-button" onClick={onSelectOther}>
          Use other...
        </button>
      </div>
    );
  }
);



// WEBPACK FOOTER //
// ./src/controller/components/LibraryImagePicker.tsx